import type { PContainer, PGraphics } from '../../engine/aliases'
import { clickEater } from '../../uiParts/clickEater-sidecar'
import type { IStevieText2 } from '../../uiParts/stevieTexts2'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { echoFonts } from '../echo/echoFonts-sidecar'
import { voyageColors } from './voyageColors-sidecar'

import { voyageSounds } from './voyageSounds-sidecar'
import { voyageUiGraphicsUtils } from './voyageUiGraphicsUtils-sidecar'

export interface IVoyageGButton {
  x: number
  y: number
  w: number
  h: number
  bevel: number
  isOver: boolean
  isDown: boolean
  onClick: (_b: IVoyageGButton) => void
  onMouseOver: (_b: IVoyageGButton) => void
  text: string
  isVisible: boolean
  isUnlocked: boolean
  isDisabled: boolean
  feather: number
  renderer: (
    g: PGraphics,
    c: IVoyageGButton,
    texts: IStevieText2[],
    layer: PContainer,
  ) => void
}

export const create = (
  text: string,
  x = 0,
  y = 0,
  onClick: (_b: IVoyageGButton) => void = () => {},
) => {
  let b: IVoyageGButton = {
    text,
    x: x,
    y: y,
    w: 100,
    h: 40,
    bevel: 8,
    isOver: false,
    isDown: false,
    onClick,
    onMouseOver: () => {},
    isVisible: true,
    isUnlocked: false,
    isDisabled: false,
    feather: 0,
    renderer: renderButton,
  }
  return b
}

export const hitTest = (
  buttons: IVoyageGButton[],
  x: number,
  y: number,
  official: boolean,
) => {
  let over: IVoyageGButton | null = null
  for (let i = 0; i < buttons.length; i++) {
    let c = buttons[i]
    if (!c.isVisible) {
      continue
    }

    if (clickEater.isCursorEaten()) {
      c.isOver = false
      c.isDown = false
      continue
    }

    let wasOver = c.isOver
    if (official) {
      c.isOver = false
    }
    if (x >= c.x - c.feather && y >= c.y - c.feather) {
      if (x <= c.x + c.w + c.feather && y <= c.y + c.h + c.feather) {
        over = c

        // console.log('button hit test over', official)

        if (official) {
          c.isOver = true
          if (!wasOver) {
            c.onMouseOver(c)
            voyageSounds.playbuttonMouseOver()
          }
          if (c.isDown && !clickEater.isLeftDownRegardless()) {
            c.isDown = false
            voyageSounds.playButtonClick()
            c.onClick(c)
            clickEater.tempEat()
          } else {
            c.isDown = false
            if (clickEater.isLeftDownRegardless()) {
              c.isDown = true
              clickEater.tempEat()
            } else {
            }
          }
        }

        // if (clickEater.isLeftFirstDownAndUneaten()) {
        //   // goatUiConfirm.setOpen(true)
        // }
      }
    }
    if (official) {
      if (!c.isOver) {
        c.isDown = false
      }
    }
  }

  return over !== null
}

export const render = (
  g: PGraphics,
  buttons: IVoyageGButton[],
  texts: IStevieText2[],
  layer: PContainer,
) => {
  for (let i = 0; i < buttons.length; i++) {
    let c = buttons[i]
    if (!c.isVisible) {
      continue
    }

    c.renderer(g, c, texts, layer)
  }
}

export const renderButton = (
  g: PGraphics,
  c: IVoyageGButton,
  texts: IStevieText2[],
  layer: PContainer,
) => {
  standardColors(g, c)
  voyageUiGraphicsUtils.bevelArea(g, c.x, c.y, c.w, c.h, c.bevel)
  g.fill()

  voyageUiGraphicsUtils.bevelArea(g, c.x, c.y, c.w, c.h, c.bevel)
  g.stroke()

  let _text = stevieTexts2.create(
    echoFonts.getData().font6,
    c.x + 16,
    c.y + 18,
    layer,
  )
  stevieTexts2.setText(_text, c.text)
  stevieTexts2.setScale(_text, 3)
  texts.push(_text)
}

export const standardColors = (g: PGraphics, c: IVoyageGButton) => {
  if (c.isOver) {
    if (c.isDown) {
      g.fillStyle(voyageColors.purpleDull, 1)
    } else {
      g.fillStyle(voyageColors.purple, 1)
    }
  } else {
    g.fillStyle(voyageColors.purpleDull, 0.9)
  }
  if (c.isUnlocked) {
    g.fillStyle(0xffffff, 0.5)
  }

  let lineColor = voyageColors.g3
  if (c.isUnlocked) {
    lineColor = 0xffffff
  }
  if (c.isDisabled) {
    lineColor = 0x777777
  }
  g.lineStyle(3, lineColor)
}

export const renderArrowLeft = (g: PGraphics, c: IVoyageGButton) => {
  standardColors(g, c)

  let x = c.x
  let y = c.y
  let w = c.w
  let h = c.h
  let bevel = 10
  let bevel2 = 10
  g.beginPath()
  g.moveTo(x, y + h / 2 - bevel2 / 2)
  g.lineTo(x + bevel, y)
  g.lineTo(x + w, y)
  g.lineTo(x + w, y + h)
  g.lineTo(x + bevel, y + h)
  g.lineTo(x, y + h / 2 + bevel2 / 2)
  g.closePath()
  g.fill()
  g.stroke()
}

export const renderArrowRight = (g: PGraphics, c: IVoyageGButton) => {
  standardColors(g, c)

  let x = c.x
  let y = c.y
  let w = c.w
  let h = c.h
  let bevel = 10
  let bevel2 = 10
  g.beginPath()
  g.moveTo(x + w, y + h / 2 - bevel2 / 2)
  g.lineTo(x + w - bevel, y)
  g.lineTo(x, y)
  g.lineTo(x, y + h)
  g.lineTo(x + w - bevel, y + h)
  g.lineTo(x + w, y + h / 2 + bevel2 / 2)
  g.closePath()
  g.fill()
  g.stroke()
}

// export const setVisible(c: IGoatGButton, isVisible: boolean) {
//   c.isVisible = isVisible
//   stevieTexts2.setVisible(c., isVisible)
// }
